import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useEffect, useRef, useState } from 'react';
import './Settingtitle.css';
import React from 'react';
import Chip from '@material-ui/core/Chip';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { I18n } from 'aws-amplify';

export default function SettingTitleForm({ listFieldActiveOfForm,setIsHasSettingTitle, props, argsAll }) {
    const filterSugguestionOption = createFilterOptions({
        ignoreCase: false,
        stringify: option => `${option.title}`
    });
    const focusMe_Ref = useRef(null);
    const [open, setOpen] = useState(false);
    const [listFiledOfForm, setListFieldOfForm] = useState([]);
    const [settingTitleOfForm, setSettingTitleOfForm] = useState([]);
    const [isRenderDefault, setIsRenderDefault] = useState(true);
    const [isError, setIsError] = useState(false);
    const [messageError, setMessageError] = useState('');

    useEffect(() => {
        let listField = [];
        let listFieldActive = [];
        let filterSysFieldList = [
            'parent',
            'children',
            'escalationOriginCustomer',
            'escalationTarget'
        ];
        let filterNotSetCustomField = [
            Constant.FORM_TYPE.MERMAID,
            Constant.FORM_TYPE.HTML,
        ]
        listFieldActive = listFieldActiveOfForm.filter(field => {
            return !filterSysFieldList.includes(field.sysField);
        });
        listFieldActive = listFieldActive.filter(field => {
            return !filterNotSetCustomField.includes(field.type);
        });
        
        listFieldActive?.forEach(field => {
            listField.push({
                id: field.id,
                title: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, field.name),
                isSelect: true
            });
        });
       
        if (argsAll?.formEdit && isRenderDefault) {
            
            const structure = Utils.convertJSONDataToObject(argsAll?.formEdit?.structure);
            
            
            let settingTitleOfFormEdit = structure?.formTitle;

            if(!Utils.isEmptyArray(argsAll.settingTitle)){
                settingTitleOfFormEdit = argsAll.settingTitle
            }

            let newSelectedTitle = [];
            
            if (
                !Utils.isEmptyArray(settingTitleOfFormEdit) &&
                !Utils.isEmptyArray(listFieldActive)
            ) {
                settingTitleOfFormEdit.forEach(item => {
                    if (!Utils.isEmptyString(item.id)) {
                        const fieldSelected = listFieldActive.find(field => {
                            return field.id === item.id || field.dummyId === item.id;
                        });
                        if (!Utils.isEmptyObject(fieldSelected)) {
                            newSelectedTitle.push({
                                id: fieldSelected.id,
                                title: Utils.getTextByLanguage(
                                    Constant.LANGUAGE_TYPE.JP,
                                    fieldSelected.name
                                ),
                                isSelect: true
                            });
                        }else{

                        }
                    }
                    if (item.isBreak) {
                        let id = new Date().getTime();
                        newSelectedTitle.push({
                            id: id,
                            title: '\n',
                            isBreak: true
                        });
                    }
                    if (Utils.isEmptyString(item.id) && !item.isBreak) {
                        const value = item.text;
                        let charArray = [];
                        for (let i = 0; i < value.length; i++) {
                            charArray.push(value.charAt(i));
                        }
                        charArray.forEach(text => {
                            let id = new Date().getTime();
                            let newOption = { id: id, title: text };
                            listField.push(newOption);
                            newSelectedTitle.push(newOption);
                        });
                    }
                });
                setIsRenderDefault(false);
                
                setSettingTitleOfForm([...newSelectedTitle]);
            }
        }
        
        if (Utils.isEmptyObject(argsAll?.formEdit) && isRenderDefault && Utils.isEmptyArray(argsAll.settingTitle)) {
            const fieldOutLine = listFieldActive.find(field => {
                return field.sysField === 'outline';
            });

            if (!Utils.isEmptyObject(fieldOutLine)) {
                
                setSettingTitleOfForm([
                    {
                        id: fieldOutLine.id,
                        title: Utils.getTextByLanguage(
                            Constant.LANGUAGE_TYPE.JP,
                            fieldOutLine.name
                        ),
                        isSelect: true
                    }
                ]);
                setIsRenderDefault(false);
            }
        }

        
        if (Utils.isEmptyObject(argsAll?.formEdit) && isRenderDefault && !Utils.isEmptyArray(argsAll.settingTitle)) {
            let newSelectedTitle = [];
            argsAll.settingTitle.forEach(item => {
                if (!Utils.isEmptyString(item.id)) {
                    const fieldSelected = listFieldActive.find(field => {
                        return field.id === item.id || field.dummyId === item.id;
                    });
                    if (!Utils.isEmptyObject(fieldSelected)) {
                        newSelectedTitle.push({
                            id: fieldSelected.id,
                            title: Utils.getTextByLanguage(
                                Constant.LANGUAGE_TYPE.JP,
                                fieldSelected.name
                            ),
                            isSelect: true
                        });
                    }
                }
                if (item.isBreak) {
                    let id = new Date().getTime();
                    newSelectedTitle.push({
                        id: id,
                        title: '\n',
                        isBreak: true
                    });
                }
                if (Utils.isEmptyString(item.id) && !item.isBreak) {
                    const value = item.text;
                    let charArray = [];
                    for (let i = 0; i < value.length; i++) {
                        charArray.push(value.charAt(i));
                    }
                    charArray.forEach(text => {
                        let id = new Date().getTime();
                        let newOption = { id: id, title: text };
                        listField.push(newOption);
                        newSelectedTitle.push(newOption);
                    });
                }
            });
            setIsRenderDefault(false);
            
            setSettingTitleOfForm([...newSelectedTitle]);
        }

        if (!isRenderDefault && !Utils.isEmptyArray(settingTitleOfForm)) {
            let newSettingTitle = [];
            let listIdOfActiveField = [];
            listFieldActive?.forEach(field => {
                if(field.dummyId){
                    listIdOfActiveField.push(field.dummyId)
                }
                listIdOfActiveField.push(field.id);
            });
            settingTitleOfForm.forEach(item => {
                if (listIdOfActiveField.includes(item.id) || !item.isSelect) {
                    newSettingTitle.push(item);
                }
            });

            if (newSettingTitle.length !== settingTitleOfForm.length) {
                
                setSettingTitleOfForm([...newSettingTitle]);
            }
        }

        setListFieldOfForm([...listField]);
    }, [listFieldActiveOfForm]);

    useEffect(() => {
        let text = '';
        let newSettingTitle = [];
        
        settingTitleOfForm?.forEach(item => {
            if (item.isSelect) {
                if (!Utils.isEmptyString(text)) {
                    newSettingTitle.push({
                        text: text,
                        id: null
                    });
                }
                newSettingTitle.push({
                    text: 'field',
                    id: item.id
                });
                text = '';
            } else if (item.isBreak) {
                if (!Utils.isEmptyString(text)) {
                    newSettingTitle.push({
                        text: text,
                        id: null
                    });
                }
                newSettingTitle.push({
                    text: '\n',
                    id: null,
                    isBreak: true
                });
                text = '';
            } else {
                text = `${text}${item.title}`;
            }
        });
        if (!Utils.isEmptyString(text)) {
            newSettingTitle.push({
                text: text,
                id: null
            });
        }
        
        argsAll.setSettingTitle([...newSettingTitle]);
    }, [settingTitleOfForm]);

    const onChangeSettingTitleOfForm = (e, value) => {
        setOpen(false);
        setSettingTitleOfForm(value);
        argsAll.setIsChangeData(true);
    };

    const getListOption = list => {
        return list.filter(option => {
            return option.isSelect && option.title;
        });
    };

    useEffect(() => {
        if (
            Utils.isEmptyString(focusMe_Ref.current.value) &&
            Utils.isEmptyArray(settingTitleOfForm)
        ) {
            setIsError(true);
            setIsHasSettingTitle(false)
            setMessageError(I18n.get('COMMSG014'));
        } else {
            setIsError(false);
            setIsHasSettingTitle(true)
            setMessageError('');
        }
    }, [settingTitleOfForm]);

    const handleOnChange = e => {
        if (Utils.isEmptyString(e.target.value) && Utils.isEmptyArray(settingTitleOfForm)) {
            setIsError(true);
            setIsHasSettingTitle(false)
            setMessageError(I18n.get('COMMSG014'));
        } else {
            setIsError(false);
            setIsHasSettingTitle(true)
            setMessageError('');
        }
        argsAll.setIsChangeData(true);
    };

    const handleOnKeyDown = e => {
        if (!open && e.key === 'Enter') {
            let newSettingTitleOfForm = [...settingTitleOfForm];
            const value = e.target.value;
            let charArray = [];
            if (value?.length > 0) {
                for (let i = 0; i < value.length; i++) {
                    charArray.push(value.charAt(i));
                }

                let newListFiledOfForm = [...listFiledOfForm];
                charArray.forEach(text => {
                    let id = new Date().getTime();
                    let newOption = { id: id, title: text };
                    newListFiledOfForm.push(newOption);
                    newSettingTitleOfForm.push(newOption);
                    setListFieldOfForm([...newListFiledOfForm]);
                });
            }
            let id = new Date().getTime();
            let newOption = { id: id, title: '\n', isBreak: true };
            newSettingTitleOfForm.push(newOption);
            setSettingTitleOfForm([...newSettingTitleOfForm]);
            argsAll.setIsChangeData(true);
        }
    };

    const handleDelete = id => {
        let newSelectOrgs = settingTitleOfForm.filter(option => {
            return option.id !== id;
        });
        
        const value = focusMe_Ref.current.value;
        
        let charArray = [];
        if (!open && value?.length > 0) {
            for (let i = 0; i < value.length; i++) {
                charArray.push(value.charAt(i));
            }
        }
        let newSettingTitleOfForm = [...newSelectOrgs];
        let newListFiledOfForm = [...listFiledOfForm];
        charArray.forEach(text => {
            let idOption = new Date().getTime();
            let newOption = { id: idOption, title: text };
            newListFiledOfForm.push(newOption);
            newSettingTitleOfForm.push(newOption);
        });
        setListFieldOfForm([...newListFiledOfForm]);
        setSettingTitleOfForm([...newSettingTitleOfForm]);
        argsAll.setIsChangeData(true);
    };

    const handelOnBlur = e => {
        const value = e.target.value;
        
        let charArray = [];
        if (!open && value?.length > 0) {
            for (let i = 0; i < value.length; i++) {
                charArray.push(value.charAt(i));
            }
        }
        let newSettingTitleOfForm = [...settingTitleOfForm];
        let newListFiledOfForm = [...listFiledOfForm];
        charArray.forEach(text => {
            let id = new Date().getTime();
            let newOption = { id: id, title: text };
            newListFiledOfForm.push(newOption);
            newSettingTitleOfForm.push(newOption);
        });
        setListFieldOfForm([...newListFiledOfForm]);
        
        setSettingTitleOfForm([...newSettingTitleOfForm]);
    };

    return (
        <div className="setting-title">
            <p className="share-option-text settingForm-title">表示形式</p>
            <Autocomplete
                className={argsAll.isFormReadOnly ? "search-option-tag-content setting-title-select item-disabled" : "search-option-tag-content setting-title-select "} 
                multiple
                filterSelectedOptions={true}
                filterOptions={filterSugguestionOption}
                getOptionLabel={option => `${option?.title}`}
                options={getListOption(listFiledOfForm)}
                value={settingTitleOfForm}
                getOptionSelected={(option, value) => option.id === value.id || option.dummyId ===value.id}
                open={open}
                onClose={() => {
                    setOpen(false);
                }}
                onChange={onChangeSettingTitleOfForm}
                disabled={argsAll.isFormReadOnly}
                renderTags={valueTag => {
                    return valueTag.map((selecedOption, index) => {
                        if (selecedOption.isBreak) {
                            return (
                                <div
                                    style={{ display: 'block', width: '100%', whiteSpace: 'pre' }}
                                ></div>
                            );
                        }
                        if (selecedOption.isSelect) {
                            return (
                                argsAll.isFormReadOnly ?
                                <Chip
                                    label={selecedOption.title}
                                    id={selecedOption.id}
                                    className="MuiChip-root setting-title"
                                /> : 
                                <Chip
                                    label={selecedOption.title}
                                    id={selecedOption.id}
                                    className="MuiChip-root setting-title"
                                    onDelete={e => {
                                        handleDelete(selecedOption.id);
                                    }}
                                />
                            );
                        } else {
                            return (
                                <div>
                                    <pre>{selecedOption.title}</pre>
                                </div>
                            );
                        }
                    });
                }}
                renderInput={params => (
                    <TextField
                        onChange={handleOnChange}
                        onKeyDown={handleOnKeyDown}
                        error={!argsAll.isFormReadOnly ? isError : false}
                        helperText={!argsAll.isFormReadOnly ? messageError : ''}
                        {...params}
                        onBlur={handelOnBlur}
                        variant="outlined"
                        inputRef={focusMe_Ref}
                        className="form-control form-control-wrapTextarea"
                    />
                )}
                ListboxProps={{
                    style: { maxHeight: 376, overflow: 'auto', overflowX: 'hidden' }
                }}
            ></Autocomplete>
            {!argsAll.isFormReadOnly && <button
                className="setting-title-btn"
                type="button"
                onClick={e => {
                    setOpen(true);
                    focusMe_Ref.current.focus();
                }}
            >
                <img src="/assets/image/icon-add-manage.svg" alt="" />
            </button>}
        </div>
    );
}
